module.exports = __webpack_public_path__ + "img/tiktok_icon.f7249afb.png";